<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{ color }}-1">
						<h4 class="card-title"><i class="material-icons" (click)="back()">arrow_left</i> Move Transactions Between Vendors</h4>
						<p class="card-category text-right">Reassign invoices, credits &amp; payments to another vendor account. Allocations are preserved.</p>
					</div>
					<div class="card-body">
						<!-- ===== Vendor pickers ===== -->
						<div class="mt-pickers">
							<div class="mt-picker">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>From vendor</mat-label>
									<i class="material-icons" matPrefix>logout</i>
									<input type="text" matInput [formControl]="fromvendor" (input)="vendorSearch($any($event.target).value, 'from')" [matAutocomplete]="autoFrom" placeholder="Search vendor…" />
									<mat-autocomplete #autoFrom="matAutocomplete" [displayWith]="displayFn" (optionSelected)="setFrom($event.option.value)">
										<mat-option *ngFor="let option of fromresults" [value]="option"><b>{{ option.supplierid }}</b> — {{ option.suppname }}</mat-option>
									</mat-autocomplete>
								</mat-form-field>
							</div>

							<div class="mt-arrow"><i class="material-icons">arrow_forward</i></div>

							<div class="mt-picker">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>To vendor</mat-label>
									<i class="material-icons" matPrefix>login</i>
									<input type="text" matInput [formControl]="tovendor" (input)="vendorSearch($any($event.target).value, 'to')" [matAutocomplete]="autoTo" placeholder="Search vendor…" />
									<mat-autocomplete #autoTo="matAutocomplete" [displayWith]="displayFn" (optionSelected)="setTo($event.option.value)">
										<mat-option *ngFor="let option of toresults" [value]="option"><b>{{ option.supplierid }}</b> — {{ option.suppname }}</mat-option>
									</mat-autocomplete>
								</mat-form-field>
							</div>
						</div>

						<!-- ===== Empty / intro state ===== -->
						<div class="mt-empty" *ngIf="!transactions && !loading">
							<i class="material-icons">swap_horiz</i>
							<p>Pick a <b>From</b> vendor to load their transactions, choose a <b>To</b> vendor, then select the rows to move.</p>
						</div>

						<div class="mt-empty" *ngIf="loading">
							<i class="material-icons spin">autorenew</i>
							<p>Loading transactions…</p>
						</div>

						<!-- ===== Working area ===== -->
						<ng-container *ngIf="transactions && !loading">
							<!-- Toolbar -->
							<div class="mt-toolbar">
								<div class="mt-toolbar-left">
									<mat-form-field appearance="outline" class="mt-search">
										<mat-label>Filter</mat-label>
										<i class="material-icons" matPrefix>search</i>
										<input matInput [formControl]="filterControl" placeholder="Doc #, reference, amount, user…" />
									</mat-form-field>

									<div class="mt-chips">
										<button type="button" class="chip chip--invoice" [class.active]="isTypeActive(20)" (click)="toggleType(20)">Invoices</button>
										<button type="button" class="chip chip--credit"  [class.active]="isTypeActive(21)" (click)="toggleType(21)">Credits</button>
										<button type="button" class="chip chip--payment" [class.active]="isTypeActive(22)" (click)="toggleType(22)">Payments</button>
									</div>
								</div>

								<div class="mt-toolbar-right">
									<span class="mt-count">{{ dataSource.filteredData.length }} of {{ totalCount }}</span>
									<button mat-raised-button class="mt-move-btn" (click)="moveTransactions()" [disabled]="selected.length === 0 || !to || moving">
										<i class="material-icons">{{ moving ? 'autorenew' : 'drive_file_move' }}</i>
										{{ moving ? 'Moving…' : (selected.length ? ('Move ' + selected.length) : 'Move') }}
									</button>
								</div>
							</div>

							<!-- Context banner -->
							<div class="mt-banner" *ngIf="from">
								<span class="mt-banner-from"><i class="material-icons">logout</i> {{ from.supplierid }} {{ from.suppname }}</span>
								<i class="material-icons mt-banner-arrow">arrow_forward</i>
								<span class="mt-banner-to" *ngIf="to"><i class="material-icons">login</i> {{ to.supplierid }} {{ to.suppname }}</span>
								<span class="mt-banner-to muted" *ngIf="!to"><i class="material-icons">login</i> choose a “To” vendor</span>
								<span class="mt-banner-sel" *ngIf="selected.length">{{ selected.length }} selected</span>
							</div>

							<!-- Table -->
							<div class="mt-table-wrap mat-elevation-z1">
								<table mat-table [dataSource]="dataSource" matSort class="mt-table">
									<ng-container matColumnDef="select">
										<th mat-header-cell *matHeaderCellDef class="col-select">
											<mat-checkbox (change)="checkAll($event)" [checked]="isAllChecked()" [indeterminate]="selected.length > 0 && !isAllChecked()"></mat-checkbox>
										</th>
										<td mat-cell *matCellDef="let t" class="col-select" (click)="$event.stopPropagation()">
											<mat-checkbox [checked]="isSelected(t)" (change)="toggleSelection(t)"></mat-checkbox>
										</td>
									</ng-container>
									<ng-container matColumnDef="transno">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Doc #</th>
										<td mat-cell *matCellDef="let t" class="mono">{{ t.transno }}</td>
									</ng-container>
									<ng-container matColumnDef="typename">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
										<td mat-cell *matCellDef="let t"><span class="pill" [ngClass]="typeClass(t)">{{ t.typename }}</span></td>
									</ng-container>
									<ng-container matColumnDef="trandate">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
										<td mat-cell *matCellDef="let t" class="nowrap">{{ t.trandate }}</td>
									</ng-container>
									<ng-container matColumnDef="duedate">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Due</th>
										<td mat-cell *matCellDef="let t" class="nowrap">{{ t.duedate || '—' }}</td>
									</ng-container>
									<ng-container matColumnDef="suppreference">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Reference</th>
										<td mat-cell *matCellDef="let t" class="ref">{{ t.suppreference || '—' }}</td>
									</ng-container>
									<ng-container matColumnDef="userid">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Entered by</th>
										<td mat-cell *matCellDef="let t">{{ t.userid || '—' }}</td>
									</ng-container>
									<ng-container matColumnDef="settled">
										<th mat-header-cell *matHeaderCellDef mat-sort-header class="center">Settled</th>
										<td mat-cell *matCellDef="let t" class="center">
											<span class="settled" [class.yes]="t.settled == 1">{{ t.settled == 1 ? 'Yes' : 'No' }}</span>
										</td>
									</ng-container>
									<ng-container matColumnDef="totalamount">
										<th mat-header-cell *matHeaderCellDef mat-sort-header class="right">Amount</th>
										<td mat-cell *matCellDef="let t" class="right amount">{{ t.totalamount | currency }}</td>
									</ng-container>
									<ng-container matColumnDef="allocated">
										<th mat-header-cell *matHeaderCellDef mat-sort-header class="right">Applied</th>
										<td mat-cell *matCellDef="let t" class="right amount">{{ t.allocated != null ? (t.allocated | currency) : '—' }}</td>
									</ng-container>
									<ng-container matColumnDef="balance">
										<th mat-header-cell *matHeaderCellDef mat-sort-header class="right">Balance</th>
										<td mat-cell *matCellDef="let t" class="right amount" [class.neg]="t.balance < 0">{{ t.balance != null ? (t.balance | currency) : '—' }}</td>
									</ng-container>

									<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
									<tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.row-selected]="isSelected(row)" (click)="toggleSelection(row)"></tr>
									<tr class="mat-row mt-no-data" *matNoDataRow>
										<td class="mat-cell" [attr.colspan]="displayedColumns.length">No transactions match the filters.</td>
									</tr>
								</table>
							</div>
							<mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
